import { BunkerProvider } from '@/providers/BunkerProvider';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { useLingui } from '@lingui/react';
import { Container, Flex, Grid, Image, Modal, SimpleGrid, Stack, Text } from '@mantine/core';
import { Icons } from '../Shares/Icons';
import { BunkerEquipSection } from './BunkerEquipSection';
import { BunkerMainSection } from './BunkerMainSection';
import { BunkerRewardSuccessItem } from './BunkerRewardSuccessItem';
import { BunkerStartButton } from './BunkerStartButton';
import classes from './BunkerSuccess.module.css';
import { BunkerSuccessSection } from './BunkerSuccessSection';
import { bunkerRewardData as data } from './data';
export const BunkerSuccessModal: React.FC = () => {
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  const {
    i18n
  } = useLingui();
  return <Modal opened={openModal === MODAL.BUNKER_SUCCESS} onClose={() => setOpenModal(null)} closeButtonProps={{
    size: 37,
    bg: 'transparent',
    icon: <Icons className="icon-pr-line-close" fontSize={37} />
  }} overlayProps={{
    bg: 'rgba(23, 26, 30, 0.96)'
  }} size="100%" classNames={classes}>
      <BunkerProvider>
        <Container size="xl" className={classes.modal}>
          <Grid gutter={{
          sm: 28,
          lg: 16
        }}>
            <Grid.Col span={{
            base: 12,
            sm: 7,
            lg: 3
          }} order={{
            base: 2,
            lg: 1
          }}>
              <Stack h="100%" maw={396} gap={20} pt={{
              sm: 20,
              lg: 0
            }} pb={35} mx="auto">
                <BunkerEquipSection />

                <Stack gap={10}>
                  <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)">
                    {i18n._('Rewards')}
                  </Text>
                  <SimpleGrid cols={2}>
                    <BunkerRewardSuccessItem key={data[0].id} {...data[0]} />
                    <BunkerRewardSuccessItem key={data[1].id} {...data[1]} />
                  </SimpleGrid>
                </Stack>

                <BunkerStartButton h={40} visibleFrom="sm" hiddenFrom="lg" />
              </Stack>
            </Grid.Col>
            <Grid.Col visibleFrom="lg" span={{
            base: 12,
            sm: 7,
            lg: 6
          }} order={2}>
              <Stack gap={32}>
                <BunkerMainSection />
              </Stack>
            </Grid.Col>
            <Grid.Col span={{
            base: 12,
            sm: 5,
            lg: 3
          }} order={{
            base: 1,
            lg: 3
          }} mt={{
            sm: -60,
            md: 0
          }} bg={{
            sm: 'var(--bg-200)',
            lg: 'transparent'
          }}>
              <Flex h="100%" direction="column" justify="center">
                <BunkerSuccessSection />

                <Image mt={40} mx="auto" src="/assets/bunker/bunker-cat-character.png" alt="bunker-avatar" w="100%" hiddenFrom="lg" />

                <BunkerStartButton h={40} my={20} hiddenFrom="sm" w={260} mx="auto" />
                <BunkerStartButton h={46} mt={28} visibleFrom="lg" />
              </Flex>
            </Grid.Col>
          </Grid>
        </Container>
      </BunkerProvider>
    </Modal>;
};